import React, { useState } from "react";
import "../Styles/Permission.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

const ChangePassword = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevVisible) => !prevVisible);
  };

  const [loading, setLoading] = useState(false);
  const [reLogin, setReLogin] = useState(false);

  const [sign, setSign] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = ({ target: { name, value } }: any) => {
    setSign({ ...sign, [name]: value });
  };

  const token = window.localStorage.getItem("token");

  // console.log(token);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault();

    api
      .patch(
        "/auth/password/update/business",
        {
          oldPassword: sign.oldPassword,
          password: sign.password,
          confirmPassword: sign.confirmPassword,
        },
        { headers: headers }
      )
      .then((res) => {
        console.log(res);
        setLoading(false);
        setSign({ oldPassword: "", password: "", confirmPassword: "" });
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          // cancelButtonColor: "red",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        if (err.response.data.message === "jwt expired" || err.response.data.message === "jwt malformed") {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  return (
    <div className="branch pass">
      {reLogin ? <ReLoginModal /> : null}
      <h2>Change Password</h2>

      <div className="pass">
        <p>Enter your password and your new password below to change your password.</p>
        <span></span>

        <form onSubmit={handleSubmit} className="infoInput">
          <div>
            <div className="input">
              <label>Old Password</label>
              <div className="inputPass">
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="**********"
                  name="oldPassword"
                  value={sign.oldPassword}
                  onChange={handleChange}
                />
                {passwordVisible ? (
                  <AiFillEyeInvisible
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <AiFillEye
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="input">
              <label>New Password</label>
              <div className="inputPass">
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="**********"
                  name="password"
                  value={sign.password}
                  onChange={handleChange}
                />
                {passwordVisible ? (
                  <AiFillEyeInvisible

                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <AiFillEye
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="input">
              <label>Confirm New Password</label>
              <div className="inputPass">
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="**********"
                  name="confirmPassword"
                  value={sign.confirmPassword}
                  onChange={handleChange}
                />
                {passwordVisible ? (
                  <AiFillEyeInvisible
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <AiFillEye
                    className="eye"
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="">
            <button type="submit" className="save">
              {loading ? (
                <CircularProgress
                  style={{ color: "#fff", width: "25px", height: "25px" }}
                />
              ) : (
                "Reset Password"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
